import { techDocs } from "../technical-docs";

export default techDocs('multidoor', 'Produtos Multidoor', 'documentos-tecnicos-produtos-multidoor')